import axiosInstance from '../../../../../services/axios/axios';
import { then } from '../../../../../services/axios/_utility';
import { WrapImsPacket } from '../../../../../store/utility';

/**
 * Asynchronously retrieves unique identifier of active, agreement-bound organization.
 *
 * @function
 * @param {string} organization name of third-party organization of interest.
 * @returns {Promise} Resolved promise providing nullable unique identifier of active, agreement-bound third-party organization.
 */
export const getOrganizationID = organization => {
	return axiosInstance
		.post(
			'api/Components/SearchBox',
			WrapImsPacket({ Key: 'ORGANIZATION_ID', Value: organization })
		)
		.then(response => {
			return then(response, payload => payload);
		})
		.catch(error => {
			throw error;
		});
};

/**
 * Asynchronously retrieves active, agreement-bound third-party organizations matching @param queryParam of user search.
 *
 * @function
 * @param {string} queryParam nullable user search input.
 * @returns {Promise} array of active, agreement-bound third-party organizations matching input query once promise resolved.
 */
export const getOrganizations = queryParam => {
	return axiosInstance
		.post(
			'api/Components/SearchBox',
			WrapImsPacket({ Key: 'ORGANIZATIONS', Value: queryParam })
		)
		.then(response => {
			return then(response, payload => payload);
		})
		.catch(error => {
			throw error;
		});
};
